import { For, Show, createMemo, lazy, onCleanup } from "solid-js";

import { getIndexComponentLists } from "@/hooks/useConfig";
import { isMobile } from "@/lib/isMobile";
import {
  FooterComponents,
  getRenderedStatus,
  updateRenderedMap,
} from "@/stores/configStore";
import { CompType } from "@/types/compontent/base/baseEnum";
import { CompontentFactory } from "@/types/compontent/compontentFactory";
import { ComponentInfo } from "@/types/swagger/front";

export default function Footer() {
  function RenderIndexComponent({ item }: { item: ComponentInfo }) {
    // 使用 CompontentFactory 创建组件实例
    const factory = CompontentFactory.getInstance();
    const component = factory.createComponent({
      ...item,
      type: item.type as CompType,
    });
    // 组件卸载时清理
    onCleanup(() => {
      factory.destroyComponent(component);
    });
    // 动态导入组件
    const DynamicComponent = lazy(async () => {
      try {
        return await import(
          `@/components/PC/Components/${item.type}/index.tsx`
        );
      } catch (e) {
        console.error(`动态导入组件失败: ${item.type}`, e);
        return {
          default: () => <div>Component loading failed:{item.type}</div>,
        };
      }
    });

    const placeHeight = createMemo(() => {
      return getRenderedStatus(item.key)
        ? "unset"
        : isMobile()
          ? item.height
          : item.pc_height;
    });
    if (!item.delay) {
      setTimeout(() => {
        updateRenderedMap(item.key, true);
      }, 100);
    }
    return (
      <div style={{ height: placeHeight() }}>
        <DynamicComponent {...component} />
      </div>
    );
  }
  return (
    <Show
      when={
        getIndexComponentLists().filter((item) =>
          FooterComponents.includes(item.type),
        ).length > 0
      }
      fallback={<></>}
    >
      <div class="bg-footer-bg3 flex flex-col gap-[24px] pb-[30px] pt-[30px]">
        <For
          each={getIndexComponentLists().filter((item) =>
            FooterComponents.includes(item.type),
          )}
        >
          {(item) => (
            <div class="wrap">
              <RenderIndexComponent item={item} />
            </div>
          )}
        </For>
      </div>
    </Show>
  );
}
